module.exports = __webpack_public_path__ + "static/media/retailShops.51437c38.png";